import {
  firstFieldError,
  getResponseMessage
} from "../../../../utils/handlers/get-response-message.ts"

/**
 * A rejected create must read as a reason, not as "something went wrong": the
 * two the wizard can actually provoke — an out-of-scope `customer_id` and a
 * missing project type — both arrive as DRF field errors with no `detail`.
 */
function createLeadErrorMessage(rejection: unknown, fallback: string): string {
  if (rejection instanceof Error) return rejection.message || fallback

  const data = rejection as Record<string, unknown> | null | undefined

  return (
    getResponseMessage(data) ||
    firstFieldError((data as { details?: unknown })?.details) ||
    firstFieldError(data) ||
    fallback
  )
}

export { createLeadErrorMessage }
